import React, { useState } from "react";
import HeaderOrbit from "../../components/HeaderOrbit";
import Container from "../../components/Container";
import FlexLayout from "../../components/LayoutFlex";
import { Flex, Box, Text, Heading } from "@edricphan2022/uikit";
import ContentHeader from "../../components/ContentHeader";
import {
  Wrapper,
  HowWorksStyle,
  BoxTop,
  BoxRoadMap,
  BoxBlockchainTech,
  WeUs,
  BoxInTouch,
  BoxContent,
} from "./styled";
import BannerGif from "../../assets/servicez/rubic.png";
import Picture from "../../components/Picture";
import IconWithArr from "../../components/IconOrbit/IconWithArr";
import { ArrBlockchainTech } from "./config";
import FormOrbit from "../HomeOrbit/FormOrbit";
import { LetterIcon, TeleIcon } from "@edricphan2022/uikit";
import TecWeUse from "./TecWeUse";
import BoxSlider from "../../assets/servicez/BoxRubic.png";
import gif1 from "../../assets/servicez/gifv2.gif";
import gif2 from "../../assets/servicez/gifv1.gif";

const HowItWorks = () => {
  return (
    <Wrapper>
      <HowWorksStyle>
        <HeaderOrbit />
        <BoxTop>
          <p>
            Vietnam Software Outsourcing Company
            <br />
            Blockchain Technology
          </p>
          <Box className="BackGround-black">
            <Picture url={BannerGif} />
            <img src={BoxSlider} alt="" className="Box1" />
            <img src={BoxSlider} alt="" className="Box2" />
            <img src={BoxSlider} alt="" className="Box3" />
            <img src={BoxSlider} alt="" className="Box4" />
          </Box>
        </BoxTop>
      </HowWorksStyle>
      <BoxRoadMap>
        <Container>
          <h1>
            Blockchain Consulting And <br /> Development Services
          </h1>
          <h2>
            Blockchain is an encrypted, distributed database shared across
            multiple computers or nodes that are part of a community or system
          </h2>
          <Box>
            <h3>{ArrBlockchainTech[0].title}</h3>
            <p>{ArrBlockchainTech[0].des}</p>
            <BoxContent className="BoxContent1" >
              <Box>
                {/* @ts-ignore */}
                {ArrBlockchainTech[0].itemList[0].map((_item, _index) => {
                  return <p key={_index}>{_item}</p>;
                })}
              </Box>
              <img src={gif1} alt="" />
              <Box>
                {/* @ts-ignore */}
                {ArrBlockchainTech[0].itemList[1].map((_item, _index) => {
                  return <p key={_index}>{_item}</p>;
                })}
              </Box>
            </BoxContent>
          </Box>
          <Box>
            <h3>{ArrBlockchainTech[1].title}</h3>
            <BoxContent className="BoxContent2">
              <Box className="BoxGroup">
                {/* @ts-ignore */}
                {ArrBlockchainTech[1].des1.map((_item, _index) => {
                  return (
                    <Box key={_index}>
                      <h4>{_item.title}</h4>
                      <p>{_item.text}</p>
                    </Box>
                  );
                })}
              </Box>
              <img src={gif2} alt="" />
              <Box className="BoxGroup" >
                {/* @ts-ignore */}
                {ArrBlockchainTech[1].des2.map((_item, _index) => {
                  return (
                    <Box key={_index}>
                      <h4>{_item.title}</h4>
                      <p>{_item.text}</p>
                    </Box>
                  );
                })}
              </Box>
            </BoxContent>
          </Box>
        </Container>
      </BoxRoadMap>
      {/* <BoxInTouch>
        <Container>
          <FlexLayout className="cus-intouch-orbit">
            <Box>
              <ContentHeader text="Talk to an expert" title="GET IN TOUCH" />
              <Text>
                Our team is happy to answer your questions.
                <br /> Fill out the form or contact us via:
              </Text>
              <Box pt="46px">
                <Flex>
                  <LetterIcon />
                  <Text pl="16px">info@technologyorbit.com</Text>
                </Flex>
                <Flex pt="7px">
                  <TeleIcon />
                  <Text pl="16px">@technologyorbit</Text>
                </Flex>
              </Box>
            </Box>
            <Box>
              <Box>
                <FormOrbit />
              </Box>
            </Box>
          </FlexLayout>
        </Container>
      </BoxInTouch> */}
    </Wrapper>
  );
};

export default HowItWorks;
